import { ContainerModule } from 'inversify';

import { BaseModule } from '@vp/common/BaseModule';
import { AccessManagerFacade } from '@vp/manager/access/core/AccessManagerFacade';
import { AccessManagerPort } from '@vp/manager/access/core/interface/AccessManagerPort';
import { AccessManagerRepository } from '@vp/manager/access/core/interface/AccessManagerRepository';
import { ApplyChangesUsecase } from '@vp/manager/access/core/usecase/ApplyChangesUsecase';
import { GenerateCodeUsecase } from '@vp/manager/access/core/usecase/GenerateCodeUsecase';
import { AccesssManagerDataMapper } from '@vp/manager/access/data/AccessManagerDataMapper';
import { RestAccessManagerRepository } from '@vp/manager/access/data/RestAccessManagerRepository';
import { AccessManagerViewModel } from '@vp/manager/access/ui/AccessManagerViewModel';

export class AccessManagerModule extends BaseModule {
  readonly module: ContainerModule = new ContainerModule(bind => {
    bind(AccessManagerFacade).toSelf().inSingletonScope();
    bind(ApplyChangesUsecase).toSelf().inSingletonScope();
    bind(GenerateCodeUsecase).toSelf().inSingletonScope();
    bind(RestAccessManagerRepository).toSelf().inSingletonScope();
    bind(AccesssManagerDataMapper).toSelf().inSingletonScope();

    bind(AccessManagerViewModel).toSelf().inTransientScope();

    bind(AccessManagerPort)
      .toDynamicValue(context => context.container.get(AccessManagerFacade))
      .inSingletonScope();

    bind(AccessManagerRepository)
      .toDynamicValue(context => context.container.get(RestAccessManagerRepository))
      .inSingletonScope();
  });
}
